<script lang="tsx" setup>
import { onMounted, watch } from "vue"
import { useRoute } from "vue-router"

import { useProjects, waitForProjects } from "@/store/projects"
import { cleanHTML } from "@/utils/clean"

const route = useRoute()

const { isLoading, studentIndex } = useProjects()

const onQueryChange = (query: string) => {
  if (query) {
    const anchor = document.querySelector(
      `#anchor_${String(query).toUpperCase()}`,
    )
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }
}

watch(
  () => route.query.a,
  val => {
    onQueryChange(val as string)
  },
)

onMounted(async () => {
  await waitForProjects()
  const query = route.query.a as string
  onQueryChange(query)
  const totalProjects = Object.values(studentIndex.value).reduce(
    (acc, group) => acc + group.length,
    0,
  )
  console.log(`Loaded ${totalProjects} projects from the project index.`)
})
</script>

<template>
  <div class="p-2">
    <div
      class="flex gap-2 py-1 border-y mb-4 flex-wrap w-full"
      v-if="isLoading"
    >
      Loading...
    </div>
    <nav class="shrink-0 sticky top-0 bg-white z-10 lg:text-sm text-xs">
      <div
        class="flex gap-x-3 items-center justify-center leading-none pt-2 pb-1 lg:pb-2 lg:pt-3 gap-y-1 border-y mb-4 flex-wrap"
        v-if="!isLoading"
      >
        <div v-for="(_group, key) in studentIndex">
          <router-link
            class="link"
            :to="{
              query: { ...route.query, a: key.toLowerCase() },
            }"
          >
            <span v-html="key"></span>
          </router-link>
        </div>
      </div>
    </nav>
    <div class="flex gap-12 w-full">
      <div class="columns-2 lg:columns-4 gap-x-linebreak w-full">
        <div
          v-for="(group, key) in studentIndex"
          class="break-inside-avoid mb-12"
        >
          <div
            class="leading-none block-link text-xs underline mb-1"
            :id="'anchor_' + key"
          >
            {{ key }}
          </div>
          <div v-for="student in group" :data-uri="student.uri">
            <RouterLink :to="`/${student.uri}`">
              <div
                class="flex gap-2 items-center lg:text-base text-sm mb-1 lg:mb-0"
              >
                <div class="inline link" v-html="cleanHTML(student.name)"></div>
              </div>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
